import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        this.updateTabsFromHash();
        window.addEventListener('hashchange', this.updateTabsFromHash);
    }

    disconnect() {
        window.removeEventListener('hashchange', this.updateTabsFromHash);
    }

    updateTabsFromHash = () => {
        const anchor = window.location.hash.replace('#', '');
        if (anchor) {
            this.element.querySelectorAll("label.d-tab>input[type='radio']").forEach((input: Element) => {
                const radio = input as HTMLInputElement;
                if (radio.id === anchor) {
                    radio.checked = true;
                    radio.click()
                }
            });
        }
    }
}
